import { Button, OdinIcon } from '@myosh/odin-components';
import type { OdinIconName } from '@myosh/odin-components';

type WrapperStyledButtonField = {
  onClick: () => void;
  buttonCaption?: string;
  hidden?: boolean;
  disabled?: boolean;
  icon?: OdinIconName;
};
const WrapperStyledButtonField = ({ onClick, buttonCaption, disabled, hidden, icon }: WrapperStyledButtonField) => {
  const getIconElement = () => {
    if (icon) {
      return <OdinIcon icon={icon} className="mr-2" />;
    }
  };

  return (
    <div className="m-1 flex h-12 items-center">
      <Button onClick={onClick} disabled={disabled} hidden={hidden} variant="alternative" icon={getIconElement()}>
        {buttonCaption}
      </Button>
    </div>
  );
};

export default WrapperStyledButtonField;
